import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { CONTENT_SETTINGS_DEFAULT, CONTENT_SETTINGS_ES_DEFAULT, BuilderContentSettings } from '../Constants/content';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANG } from '../Constants/constants';

// Define content settings mapping by language
const CONTENT_SETTINGS_BY_LANGUAGE = {
  [SUPPORTED_LANG.EN]: (state: any) => JSON.parse(state.builder?.settings?.content_settings || '{}'),
  [SUPPORTED_LANG.ES]: (state: any) => JSON.parse(state.builder?.settings?.content_settings_es || '{}')
};

// Define default content settings by language
const DEFAULT_CONTENT_SETTINGS_BY_LANGUAGE = {
  [SUPPORTED_LANG.EN]: CONTENT_SETTINGS_DEFAULT,
  [SUPPORTED_LANG.ES]: CONTENT_SETTINGS_ES_DEFAULT
};

export const useContentSettings = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  
  // Get the appropriate content settings based on current language
  const content_settings = useSelector((state: any) => {
    // Get the correct selector function from the mapping or default to English if language not supported
    const contentSelector = CONTENT_SETTINGS_BY_LANGUAGE[currentLanguage] || CONTENT_SETTINGS_BY_LANGUAGE[SUPPORTED_LANG.EN];
    return contentSelector(state);
  }) as BuilderContentSettings;

  // Get the default content settings for the current language
  const defaultSettings = DEFAULT_CONTENT_SETTINGS_BY_LANGUAGE[currentLanguage] || CONTENT_SETTINGS_DEFAULT;

  return useCallback((key: keyof BuilderContentSettings) => {
    return content_settings[key] || defaultSettings[key];
  }, [content_settings, defaultSettings]);
}
